import { render, staticRenderFns } from "./ModalApp.vue?vue&type=template&id=97c9c974&"
import script from "./ModalApp.vue?vue&type=script&lang=js&"
export * from "./ModalApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports